import axiosBackEnd from "../config/axios/axios-back-end";


const triggerEnvelops = async (data) => {
  const result = await axiosBackEnd.post("/api/qcapp/triggerEnvp", data);
  return result.data;
};

const requestReportQc = async (data) => {
  const result = await axiosBackEnd.post("/api/qcapp/reportQc", data);
  return result.data;
};

const requestHotelQc = async (data) => {
  const result = await axiosBackEnd.post("/api/qcapp/hotelQc", data);
  return result.data;
};

export { triggerEnvelops, requestReportQc, requestHotelQc };